import styled from 'styled-components'
import { H, InfoCircleIcon, P, Wrapper } from '@farewill/ui'
import { COLOR, GTR } from '@farewill/ui/tokens'

const StyledWrapper = styled(Wrapper)`
  display: flex;
  align-items: center;
  margin-bottom: ${GTR.S};
`

export const TelephonePaymentNote = ({
  isConverted,
  takingPayment,
  paymentSystemUsed,
  paymentButtonLabel,
}: {
  isConverted: boolean
  takingPayment: boolean
  paymentSystemUsed?: 'PCI PAL'
  paymentButtonLabel: string
}) => {
  const convertedMessage = paymentSystemUsed
    ? `Payment has been taken via ${paymentSystemUsed} and this lead is converted.`
    : 'Payment has been taken and this lead is converted.'

  return (
    <Wrapper background={COLOR.BACKGROUND.SMOKE} padding={GTR.M}>
      <StyledWrapper>
        <InfoCircleIcon size="M" />
        <H
          color={COLOR.GREY.DARK}
          tag="h5"
          size="XS"
          margin={[0, 0, 0, GTR.XS]}
          data-testid="payment-note-heading"
        >
          {isConverted
            ? convertedMessage
            : takingPayment
              ? 'Successfully took a payment?'
              : 'Taking payments'}
        </H>
      </StyledWrapper>
      {isConverted ? (
        <></>
      ) : takingPayment ? (
        <P>
          If you’ve successfully taken payment, go ahead and convert the lead.
          Otherwise, click <strong>{paymentButtonLabel}</strong> again.
        </P>
      ) : (
        <P>
          Click <strong>{paymentButtonLabel}</strong> to open a new tab. The
          customer can enter their card details securely using their phone
          keypad - no need to pause the call recording. Return here when you’re
          done.
        </P>
      )}
    </Wrapper>
  )
}
